import React from "react";
import { FlaskConical, CheckCircle2 } from "lucide-react";
import { Card } from "./ui";

// Same dosing steps the shop's water test gives for this pool
const doseText = (s) => s.title + (s.lines?.length ? ` (${s.lines.map((l) => `${l.qty} × ${l.name}`).join(" + ")})` : "");

export default function DoseResults({ steps, mineral, ticked = [], onTick, onWo }) {
  const tick = (t, s) => onTick && onTick(ticked.includes(t) ? ticked.filter((x) => x !== t) : [...ticked, t], s, !ticked.includes(t));
  if (!steps.length && !mineral?.applicable) return (
    <Card className="flex items-center gap-3 text-[18px] font-black text-green-700" data-testid="tech-dose-none"><CheckCircle2 className="h-8 w-8" />Water is balanced — no chemicals needed</Card>
  );
  return (
    <div className="space-y-2" data-testid="tech-dose">
      <div className="flex items-center gap-2 text-[15px] font-black text-slate-500 uppercase tracking-wide"><FlaskConical className="h-5 w-5" />Dose the pool in this order{onTick && " · tick each one added"}</div>
      {steps.map((s, i) => { const on = ticked.includes(doseText(s)); return (
        <Card key={s.id} className={`!p-3 space-y-1 ${on ? "ring-2 ring-green-500 bg-green-50" : ""}`} data-testid={`tech-dose-step-${s.action}`} onClick={() => tick(doseText(s), s)}>
          <div className="flex gap-2.5 items-start">
            <span className={`h-8 w-8 shrink-0 rounded-lg border-[3px] text-[15px] font-black flex items-center justify-center ${on ? "bg-green-600 border-green-600 text-white" : "border-cyan-600 text-cyan-700 bg-white"}`} data-testid={`tech-dose-tick-${s.action}`}>{on ? "✓" : i + 1}</span>
            <div className="min-w-0">
              <div className="text-[17px] font-black text-slate-900 leading-snug">{s.title}</div>
              {s.text && <div className="text-[14px] text-slate-600 leading-snug">{s.text}</div>}
              {s.lines?.length > 0 && <div className="text-[14px] font-bold text-cyan-800 mt-0.5">{s.lines.map((l) => `${l.qty} × ${l.name}`).join(" + ")}{on && onTick && <span className="text-green-700"> · {onWo ? "on the work order" : "added to this job"}</span>}</div>}
            </div>
          </div>
        </Card>
      ); })}
      {mineral?.applicable && mineral.options?.length > 0 && (
        <Card className="!p-3 space-y-1" data-testid="tech-dose-mineral">
          <div className="text-[17px] font-black text-slate-900">Mineral salt top-up</div>
          {mineral.options.map((o, i) => <div key={i} className="text-[14px] text-slate-700"><b>{o.label}:</b> {o.lines.map((l) => `${l.qty} × ${l.name}`).join(" + ")}</div>)}
        </Card>
      )}
    </div>
  );
}
